import { render, staticRenderFns } from "./AllocatingWaitingList.vue?vue&type=template&id=3f9b060e"
import script from "./AllocatingWaitingList.vue?vue&type=script&lang=js"
export * from "./AllocatingWaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports